/* Hero final frame → native Shopify consent → normal sticky purchase visibility. */
(function () {
  'use strict';

  if (window.Shopify?.designMode) return;

  const root = document.documentElement;
  const selector = '[data-sl-hero-motion], #shopify-pc__banner, #shopify-pc__prefs';
  let hero;
  let banner;
  let preferences;

  function isOpen(element) {
    return Boolean(element?.isConnected && !element.hidden && element.style.display === 'block');
  }

  function sync() {
    const bannerOpen = isOpen(banner);

    const introPending = hero?.isConnected && hero.dataset.introComplete !== 'true'
      && !root.hasAttribute('data-c2o3-intro-fallback');
    const privacy = window.Shopify?.customerPrivacy;
    const consent = privacy?.currentVisitorConsent?.();
    const consentPending = privacy?.shouldShowBanner?.() === true && consent
      && ['marketing', 'analytics', 'preferences'].every(key => consent[key] === '');
    root.toggleAttribute('data-c2o3-entry-blocked', Boolean(
      introPending || consentPending || bannerOpen || isOpen(preferences)
    ));
  }

  const stateObserver = new MutationObserver(sync);

  function observeComponents() {
    stateObserver.disconnect();
    hero = document.querySelector('[data-sl-hero-motion]');
    banner = document.getElementById('shopify-pc__banner');
    preferences = document.getElementById('shopify-pc__prefs');
    [hero, banner, preferences].filter(Boolean).forEach(element => {
      stateObserver.observe(element, {
        attributes: true,
        attributeFilter: ['data-intro-complete', 'style', 'hidden']
      });
    });
    sync();
  }

  function start() {
    observeComponents();
    // Shopify inserts/removes its banner asynchronously; section swaps can replace the hero.
    new MutationObserver(records => {
      const componentsChanged = records.some(record =>
        [...record.addedNodes, ...record.removedNodes].some(node =>
          node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
        )
      );
      if (componentsChanged) observeComponents();
    }).observe(document.body, { childList: true, subtree: true });
  }

  ['consentTrackingApiLoaded', 'shopifyCustomerPrivacyApiLoaded', 'visitorConsentCollected'].forEach(name => {
    document.addEventListener(name, sync);
  });
  window.addEventListener('pageshow', sync);
  window.addEventListener('load', () => {
    // A missing hero asset must not keep the consent UI hidden.
    if (!window.SLHeroMotion) root.setAttribute('data-c2o3-intro-fallback', '');
    sync();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
